import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { handleAPIError } from '@/utils/handle-api-error';
import { createBillingPortalSessionAction } from '@/redux/actions/company';
import { createBillingPortalSession, TCreateBillingPortalSessionResponse } from '@/services/api/company';

export function* createBillingPortalSessionSaga(
  action: ActionType<typeof createBillingPortalSessionAction.request>,
): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(createBillingPortalSession, materials);
    const portalResponse: TCreateBillingPortalSessionResponse = response as TCreateBillingPortalSessionResponse;
    yield put(createBillingPortalSessionAction.success(portalResponse));
    successCallback?.(portalResponse);
  } catch (err) {
    handleAPIError(err, 'Error.createBillingPortalSessionError');
    yield put(createBillingPortalSessionAction.failure(err));
    failedCallback?.(err);
  }
}
